var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"mr-12"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'lightbulb-on']}})],1),_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }